var exports = {
  "Vx": "xaee3c4fa--36e8b3--search-container",
  "$P": "xaee3c4fa--36e8b3--search",
  "U": "xaee3c4fa--36e8b3--search-form",
  "Ff": "xaee3c4fa--36e8b3--search-form__reset",
  "Cc": "xaee3c4fa--36e8b3--search-form__submit",
  "jg": "xaee3c4fa--36e8b3--search-form__no-result",
  "uR": "xaee3c4fa--36e8b3--search-preloader",
  "tp": "xaee3c4fa--36e8b3--result-global__item--hash",
  "ht": "xaee3c4fa--36e8b3--result-global__item--category",
  "H$": "xaee3c4fa--36e8b3--result-global__item--category__type",
  "ie": "xaee3c4fa--36e8b3--result-global",
};

module.exports = exports;
